"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTableProductionOrderStation = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DmsTable = require("../../DmsTable/DmsTable");
var _DmsButtonGroup = require("../../DmsButtonGroup/DmsButtonGroup");
var _DmsTableEditButton = require("../../DmsTableButton/DmsTableEditButton");
var _DmsTableDeleteButton = require("../../DmsTableButton/DmsTableDeleteButton");
var _DmsFlexContainer = require("../../DmsFlexContainer/DmsFlexContainer");
var _DmsPermissions = require("../../DmsPermissions/DmsPermissions");
var _Permissions = require("../../../constants/Permissions");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
var _DmsCreateProductionOrderStationButton = require("./DmsCreateProductionOrderStationButton");
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * DmsTableProductionOrderStation.
 * Renders a DmsTable with Production order station datas to specifica production_order
 * @param {object} row_data - data of table production_order
 * @component
 * @example
 * return (
 *   < DmsTableProductionOrderStation 
 *      row_data = {row_data}/>
 * )
 */

const DmsTableProductionOrderStation = _ref => {
  let {
    row_data
  } = _ref;
  const table = (0, _react.useRef)(null);
  const header = [{
    label: _reactIntlUniversal.default.get("Index").d("Index"),
    column_name: "pk",
    can_create: false,
    can_edit: false,
    filter: false,
    hidden: true
  }, {
    label: _reactIntlUniversal.default.get("ProductionOrder").d("Production order"),
    column_name: "production_order_pk",
    can_create: false,
    can_edit: false,
    filter: false,
    hidden: true
  }, {
    label: _reactIntlUniversal.default.get("StationName").d("Station name"),
    column_name: "station",
    form_column_name: "station_pk",
    control: 'select',
    function: station => (station || {}).name,
    url: "/station/all",
    properties: {
      label: "name",
      value: "pk",
      column_name: 'name',
      filter: {
        value: "pk",
        field: "station_pk"
      }
    },
    placeholder: "(unchanged)",
    filter: false,
    sortable: false
  }, {
    label: _reactIntlUniversal.default.get("Actions").d("Actions"),
    width: "5vw",
    sortable: false,
    element: row => {
      const name = row.station.name;
      return /*#__PURE__*/_react.default.createElement(_DmsButtonGroup.DmsButtonGroup, null, /*#__PURE__*/_react.default.createElement(_DmsTableEditButton.DmsTableEditButton, {
        table: table,
        title: _reactIntlUniversal.default.get("UpdateProductionOrderStation", {
          name
        }).d("Update relation production order station with name {name}"),
        url: "/production_order_station",
        row: row
      }), /*#__PURE__*/_react.default.createElement(_DmsTableDeleteButton.DmsTableDeleteButton, {
        table: table,
        title: _reactIntlUniversal.default.get("DeleteStationRelationProductionOrder", {
          name
        }).d("Delete station {name} of production order"),
        text: _reactIntlUniversal.default.get("Station.DeleteMensage", {
          name
        }).d("Delete relation production order station with name {name}. Are you sure about it?"),
        url: "/production_order_station",
        row_pk: row.pk
      }));
    }
  }];
  const toolbar = /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer, null, /*#__PURE__*/_react.default.createElement(_DmsFlexContainer.DmsFlexContainer.Left, null, /*#__PURE__*/_react.default.createElement(_DmsPermissions.DmsPermissions, {
    permissions: _Permissions.Permissions.CAN_EDIT_PART
  }, /*#__PURE__*/_react.default.createElement(_DmsCreateProductionOrderStationButton.DmsCreateProductionOrderStationButton, {
    row_data: row_data,
    table: table
  }))));
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_DmsTable.DmsTable, {
    ref: table,
    url: "production_order_station/get_all_station/" + row_data.pk,
    responsive: false,
    header: header,
    needs_authentication: true,
    managed: true,
    toolbar: toolbar,
    paging: false
  }));
};
exports.DmsTableProductionOrderStation = DmsTableProductionOrderStation;
DmsTableProductionOrderStation.propTypes = {
  row_data: _propTypes.default.shape({
    pk: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]).isRequired
  }).isRequired
};